webpackJsonp([210291689255265],{

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SheShines = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(18);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(13);
	
	__webpack_require__(12);
	
	var _reactLinkedinInsight = __webpack_require__(16);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/AnkitaBalotia.png";
	var icon2 = "https://winpeforum.com/assets/elements/CharuGulati.jpg";
	var icon3 = "https://winpeforum.com/assets/elements/Hemangi.jpg";
	var icon4 = "https://winpeforum.com/assets/elements/KrunaliShah.jpg";
	var icon5 = "https://winpeforum.com/assets/elements/NishthaKohli.jpg";
	var icon6 = "https://winpeforum.com/assets/elements/ParitaAshar.jpg";
	var icon7 = "https://winpeforum.com/assets/elements/PoojaParmar.jpg";
	var icon8 = "https://winpeforum.com/assets/elements/PrachiMarwah.jpg";
	var icon9 = "https://winpeforum.com/assets/elements/SanjnaTulsiani.jpg";
	var icon10 = "https://winpeforum.com/assets/elements/SarikaSaxena.jpg";
	var icon11 = "https://winpeforum.com/assets/elements/ShwetaLaddha.jpg";
	var icon12 = "https://winpeforum.com/assets/elements/SnigdhaJain.jpg";
	
	var duration = 400;
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SheShines = exports.SheShines = function (_React$Component) {
	  _inherits(SheShines, _React$Component);
	
	  function SheShines(args) {
	    _classCallCheck(this, SheShines);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	    _this.Speaker2 = [{
	      imgUrl: icon1,
	      desc: "<div>\nAnkita Balotia is Vice President on the Investment team at Fireside Ventures, working hands-on with six portfolio companies\u2014including Pilgrim, Kapiva, Sweet Karam Coffee, and Frubon\u2014on growth, product, and go-to-market. Prior to Fireside, she was an investor at Venture Highway (General Catalyst India), backing multiple consumer technology businesses across stages. Ankita began her career in management consulting, spending over five years at Bain & Company and Strategy& (formerly Booz & Company), where she advised clients in consumer tech, telecom, real estate, and healthcare on strategy and execution. She holds a B.Tech in Computer Science from IIT Delhi and an MBA from IIM Ahmedabad.\n\n \n          </div>",
	      name: "Ankita Balotia",
	      post: "<div>Vice President on the Investment team<br/>Fireside Ventures\n\n\n          </div>"
	    }];
	    _this.Speaker1 = [{
	      imgUrl: icon1,
	      desc: "<div>\nAnkita Balotia is Vice President on the Investment team at Fireside Ventures, working hands-on with six portfolio companies\u2014including Pilgrim, Kapiva, Sweet Karam Coffee, and Frubon\u2014on growth, product, and go-to-market. Prior to Fireside, she was an investor at Venture Highway (General Catalyst India), backing multiple consumer technology businesses across stages. Ankita began her career in management consulting, spending over five years at Bain & Company and Strategy& (formerly Booz & Company), where she advised clients in consumer tech, telecom, real estate, and healthcare on strategy and execution. She holds a B.Tech in Computer Science from IIT Delhi and an MBA from IIM Ahmedabad.\n\n \n          </div>",
	      name: "Ankita Balotia",
	      post: "<div>Vice President on the Investment team<br/>Fireside Ventures\n\n\n          </div>"
	    }, {
	      imgUrl: icon2,
	      desc: "<div>\nCharu Gulati is the Chief Human Resources Officer (CHRO) at Everstone Group, India, where she plays a pivotal strategic and operational role in aligning the firm\u2019s talent agenda with its investment objectives. She leads human capital initiatives across the firm and its portfolio companies, focusing on leadership assessment, organizational design, succession planning, and culture building. <Br/><Br/>\nBefore joining Everstone, Charu served as Director of Human Resources at IDFC Bank, where she was responsible for HR strategy and execution across both retail and wholesale banking operations. Earlier in her career, she spent over 15 years at Genpact, where she held leadership roles in operations and HR, managing finance and accounting offshore businesses across a diverse range of industries. <br/><Br/>\nCharu holds a Diploma in Hotel Management from the Institute of Hotel Management, Catering Technology and Applied Nutrition, and a Post Graduate Certificate in Human Resources from XLRI, Jamshedpur.\n\n\n          </div>",
	      name: "Charu Gulati",
	      post: "<div>CHRO<br/> Everstone Group, India\n\n          </div>"
	    }, {
	      imgUrl: icon3,
	      desc: "<div>\n    Hemangi has been a seasoned banker with 14 years of experience across investment and corporate banking. At Trifecta Capital, Hemangi is a Director for Venture Debt Investments, leading investments with startups like Rebel Foods, Bharatpe, Rupeek, Moneyview, Alt Mobility, Practo, and Slurrp Farm. Previously  at ICICI Bank, she led startup and tech coverage across Western India and before that at  Nomura, she worked on M&A and ECM deals across Southeast Asia and the U.S. An angel investor and advisor, she brings a 360\xB0 approach to founder and investor partnerships. She holds an MBA from NMIMS.  \n\n          </div>",
	      name: "Hemangi",
	      post: "<div>Director for Venture Debt Investments<br/>Trifecta Capital\n\n          </div>"
	    }, {
	      imgUrl: icon4,
	      desc: "<div>\n    Krunali Shah has been an Investor with A91 Partners for 5 years. She is involved with investments across consumer brands, financial services and technology. Prior to joining A91, Krunali was a part of the Boston Consulting Group. She has graduated from IIM Ahmedabad and is a Chartered Accountant. \n\n\n          </div>",
	      name: "Krunali Shah Pinjani",
	      post: "<div>Investor<br/> A91 Partners\n\n          </div>"
	    }, {
	      imgUrl: icon5,
	      desc: "<div>\n    Nishtha Kohli is based in Mumbai and is a Senior Vice President at Warburg Pincus focused on investments in India. She has been with Warburg for 5 years and has been instrumental in leading investment efforts in the BPO and IT Services sector including Warburg's recent deal, Everise ($1Bn transaction in healthcare outsourcing services). Prior to joining Warburg Pincus, she was a Vice President at Credit Suisse New York within the Global Industrials Investment Banking Division where she focused on mergers and acquisitions. Nishtha holds a BA in Mass Media and Economics from St. Xavier\u2019s College, Mumbai, where she was a gold medalist and an MBA from The University of Chicago Booth School of Business.\n\n\n\n          </div>",
	      name: "Nishtha Kohli",
	      post: "<div>Senior Vice President<br/>Warburg Pincus\n\n          </div>"
	    }, {
	      imgUrl: icon6,
	      desc: "<div>\n    Ms. Parita Ashar is a Principal at OIJIF and has 14 years of experience, including 8 years in Private Investing. She manages several of OIJIF\u2019s investments across the Financial Services and Consumer sectors and brings full-cycle investment experience\u2014from origination to successful exits. Parita has delivered multiple exits through IPOs and secondary transactions in OIJIF\u2019s portfolio companies. Before joining OIJIF, Parita led research coverage of listed companies across various sectors at Ambit\u2019s Institutional Equity Research division. She is a Chartered Accountant and a CFA Charter holde\n \n          </div>",
	      name: "Parita Ashar",
	      post: "<div>Principal<Br/>OIJIF\n          </div>"
	    }, {
	      imgUrl: icon7,
	      desc: "<div>\n    Pooja Parmar is a seasoned investment professional based in Mumbai with 8 plus years of experience in venture capital. She is currently a Principal at Equanimity Investments. She looks at investments end to end right from sourcing to exit. She has led deals like Renee cosmetics, Insurance Samadhan, Edept, Navata supply chain solutions, Biva Analytics amongst others. She earlier worked at Housing.com, and PwC in the finance domain. Pooja is a Chartered accountant and has done her bachelors in commerce from University of Mumbai.\n\n          </div>",
	      name: "Pooja Parmar",
	      post: "<div>Principal<br/>Equanimity Investments\n\n          </div>"
	    }, {
	      imgUrl: icon8,
	      desc: "<div>\n    Prachi is a Sr. Vice President at ChrysCapital, where she focuses on investments with particular focus on the Consumer sector. She has been with the firm since 2019 and has played a key role in evaluating fresh deals and managing portfolio companies across the consumer landscape.\n <Br/><Br/>\nPrior to ChrysCapital, Prachi was with Baring Private Equity Partners India, where she worked on investments across multiple sectors. Prachi has an MBA from the Wharton School, University of Pennsylvania, She is passionate about mentorship and actively engages with young investment professionals \u2014 both within and outside ChrysCapital\u2014to help them navigate and grow in the industry.\n\n\n          </div>",
	      name: "Prachi Marwah",
	      post: "<div>Sr. Vice President<br/>ChrysCapital\n\n\n          </div>"
	    }, {
	      imgUrl: icon9,
	      desc: "<div>\n    Sanjna has 10+ years of experience across venture growth investing, investor relations and equity research.  At Iron Pillar, she has been involved in the entire deal lifecycle from sourcing, due diligence and documentation to portfolio company monitoring and exit. \n<br/><Br/>\nSanjna is a CFA\xAE Charter holder. She holds a Masters in Commerce (Finance & Accounting) and Bachelors in Management Studies (Finance) from the University of Mumbai.\n\n\n          </div>",
	      name: "Sanjna Tulsiani",
	      post: "<div>Senior Vice President<br/>Iron Pillar\n\n\n\n          </div>"
	    }, {
	      imgUrl: icon10,
	      desc: "<div>\n   Sarika Saxena is the Managing Partner at IAN Alpha Fund, an offshoot of the Indian Angel\nNetwork, with over 25 years of experience across Indian, UK, and US markets. She has spent\nover 20 years in the start-up, PE, and VC space.<Br/><Br/>\nHer expertise includes M&amp;A (heading M&amp;A at Mphasis), cross-border transactions, debt &amp;\nequity, and fund raising, notably raising $42m for Value Based Housing Corporation. Sarika\nalso played a pivotal role in establishing the innovative NBFC, Nfin. She holds an MBA from\nthe London Business School.\n\n\n          </div>",
	      name: "Sarika Saxena",
	      post: "<div> Managing Partner<br/>IAN Alpha Fund\n\n\n\n          </div>"
	    }, {
	      imgUrl: icon11,
	      desc: "<div>\n  Shweta Laddha is the Senior Vice President and Head of Compliance & Secretarial at Multiples Private Equity Group. With over 16 years of experience spanning Compliance, Secretarial, Legal, and Investment Banking, Shweta brings a strategic and solutions-oriented approach to governance and regulatory affairs. At Multiples, she not only oversees group-level compliance but also plays a pivotal role in strengthening governance frameworks across portfolio companies.\n <br/><Br/>\nHer career includes leadership roles at NIIF Infrastructure Finance Limited, Aditya Birla Capital Group, and BOB Capital Markets, where she led complex transactions including fund raising and corporate restructuring. Shweta has worked extensively with financial regulators and has built robust compliance and secretarial functions from the ground up. She holds professional qualifications as a Company Secretary, LLB, and PGDM.\n\n\n          </div>",
	      name: "Shweta Laddha",
	      post: "<div> Senior Vice President and Head of Compliance & Secretarial<br/>Multiples Private Equity Group\n\n\n\n          </div>"
	    }, {
	      imgUrl: icon12,
	      desc: "<div>\n  Ms. Jain has 21 years of experience in capital raising, investor relations and business development across financial services and is responsible for offshore fund raise and investor relations at Ascertis Credit. Prior to joining the firm, Ms. Jain was with Kotak Investment Advisors Limited as Executive Director - Capital Raising, responsible for capital raising and investor relationships for multiple products within the Kotak alternatives platform. She has also worked with Marsh India Insurance Brokers and IL&FS Trust Company Ltd (now Vistra) providing customized risk solutions and product sales within the financial services sector.\n\n\n\n\n          </div>",
	      name: "Snigdha Jain",
	      post: "<div> Executive Vice President<br/>Ascertis Credit\n\n\n\n\n          </div>"
	    }];
	
	    return _this;
	  }
	
	  SheShines.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  SheShines.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  SheShines.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Winpe Ignite Career Talk Session",
	        image: "https://winpeforum.com/api/src/templates/emailers/assets/newsletter2022.png",
	        description: "Anchored in the theme Charting Your Course, the breakout conversations highlighted how Senior women across Private Equity, Early Growth- Late VC, Early-Stage VC, and Operating Roles carve distinct paths to success. ",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_event" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/events/" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                " Back to Events"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "div",
	              { className: "m_heading" },
	              "Winpe Ignite Career Talk Session  "
	            ),
	            _react2.default.createElement("div", { className: "r_btm" }),
	            _react2.default.createElement(
	              "div",
	              { className: "date_heading" },
	              _react2.default.createElement(
	                "div",
	                { className: "date_heading" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "November 15, 2025"
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  " ",
	                  _react2.default.createElement(
	                    "i",
	                    null,
	                    "Online"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text", style: { textAlign: 'justify' } },
	              "On 15th November 2025, we hosted another edition of Winpe\u2019s PEVC Career Talk Series \u2014 this time diving into the theme \u201CCharting Your Course: Lessons from Women Who\u2019ve Redefined Success in PE/VC\u201D",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "There were four breakout rooms, each led by three expert speakers. The rooms covered Private Equity, Early Growth, Late VC, Early-Stage VC, and Operating Roles.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Participants had the flexibility to move between breakout rooms throughout the session, allowing them to listen in on various discussions and gain a broad perspective from all the speakers.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Anchored in the theme Charting Your Course, the breakout conversations highlighted how Senior women across Private Equity, Early Growth- Late VC, Early-Stage VC, and Operating Roles carve distinct paths to success. The discussions surfaced practical advice on decision-making, leadership, value creation, and building durable careers in an evolving PE/VC landscape. The session saw 95% positive feedback from the attendees!",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Catch the full recording ",
	              _react2.default.createElement(
	                "a",
	                { href: "https://www.youtube.com/playlist?list=PLu3vBoq2n-PqWON-HWyen1--uHu8R56n-", target: "_blank", style: { color: 'blue', textDecoration: 'underline' } },
	                "here"
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Through sessions like these, Winpe continues its mission to empower women with the tools and perspective they need to enter and thrive in the ever-evolving culture of PEVC.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h3",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Key Highlights:"
	                )
	              ),
	              _react2.default.createElement(
	                "h4",
	                { style: { textDecoration: 'underline' } },
	                "Operating Roles:"
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Own your function"
	                  ),
	                  " \u2014 HR, Compliance, and Fundraising are strategic enablers, not back-end roles. Recognition comes from adding value, not seeking visibility."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Understand the business deeply"
	                  ),
	                  " \u2014 knowing the investment lifecycle end-to-end builds credibility and positions you as a true partner to deal teams."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Influence through solutions"
	                  ),
	                  " \u2014 bring alternatives, context, and judgment. Be seen as someone who helps get deals done while safeguarding the firm."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Network with purpose"
	                  ),
	                  " \u2014 meaningful conversations, LinkedIn outreach, industry forums, and small peer groups all help build mentors and advocates."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Create your own mentorship circle"
	                  ),
	                  " \u2014 seek seniors, peers, and cross-functional leaders; mentorship in operating roles is often informal and self-driven."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Balance structure with judgment"
	                  ),
	                  " \u2014 say \u201Cno\u201D when required, but always pair it with a practical, business-aligned path forward."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Advice to women"
	                  ),
	                  " \u2014 be confident, be prepared, stay curious, invest in relationships, and build expertise that makes you indispensable."
	                )
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h4",
	                { style: { textDecoration: 'underline' } },
	                "Private Equity: "
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Master the investment toolkit"
	                  ),
	                  " \u2014 sourcing, sector mapping, diligence, and financial modelling shape your credibility; excellence in these basics is what accelerates you."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Build conviction the right way"
	                  ),
	                  " \u2014 ask sharper questions, test assumptions, and form independent perspectives. Strong investors balance intuition with evidence."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Have a clear point of view"
	                  ),
	                  " \u2014 track sectors, write theses, and debate ideas. A differentiated POV shows partners how you think and strengthens your influence."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Communicate for ICs"
	                  ),
	                  " \u2014 be crisp, structured, and transparent on risks. The way you present can often matter as much as what you present."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Invest in your network "
	                  ),
	                  "\u2014 founders, bankers, operators, and other investors become long-term deal-flow enablers. Your network compounds into an edge."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Learn the \u2018art\u2019 of investing"
	                  ),
	                  " \u2014 pattern recognition, timing, and deal instincts come from exposure, reflection, and staying curious about how businesses evolve."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Advice to women"
	                  ),
	                  " \u2014 speak with confidence, ask tough questions, claim your space, and build relationships that recognise and amplify your strengths."
	                )
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h4",
	                { style: { textDecoration: 'underline' } },
	                "Early Growth - Late VC"
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Combine analysis with intuition"
	                  ),
	                  " \u2014 Build conviction with rigorous financial modeling, but also rely on intuition, sector patterns, and founder signals. Numbers guide you; judgment closes the deal."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Add real value"
	                  ),
	                  " \u2014 Go beyond capital: help founders with hiring, strategy, and execution gaps. Be hands-on without micromanaging. Your support builds trust and improves outcomes."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Be patient but proactive"
	                  ),
	                  " \u2014 Navigate periods of uncertainty by giving founders space while remaining engaged. Use your network to provide timely strategic advice."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Invest in the team, not just the idea"
	                  ),
	                  " \u2014 A founder\u2019s vision matters, but execution ability, repeatable frameworks, and the right cap table are decisive. "
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Earn internal credibility"
	                  ),
	                  " \u2014 Complete work accurately, anticipate next steps, and provide unbiased insights. Move from executor \u2192 thought partner \u2192 strategic contributor."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Leverage mentors and networks"
	                  ),
	                  " \u2014 Observe leaders you respect. Mentorship can be formal or peer-based. It shapes judgment, leadership style, and career trajectory."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Evolve your impact"
	                  ),
	                  " \u2014 Start with execution, then add value, influence strategy, and eventually shape the ecosystem. Become indispensable to founders, colleagues, and LPs alike."
	                )
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h4",
	                { style: { textDecoration: 'underline' } },
	                "Early-Stage VC"
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Breaking in"
	                  ),
	                  " \u2014 No standard path. CFA/CA helps, but functional depth, sector expertise, and initiative matter more. Proactive outreach, research theses, or pro bono angel investing can open doors."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Skills that matter"
	                  ),
	                  " \u2014 Building founder rapport, reading business models, spotting opportunities\u2014financial modeling is secondary at the outset."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Paths into VC"
	                  ),
	                  " \u2014 You can start in deals or functional roles (marketing, HR, ESG, strategy). Early-stage firms value domain knowledge and operational experience as much as deal execution."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Decision-making"
	                  ),
	                  " \u2014 Early-stage bets = conviction in founders over models. Understanding team dynamics often predicts success better than numbers."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Mentorship"
	                  ),
	                  " \u2014 Essential. Internal mentors guide deal execution, external mentors help strategic growth, network expansion, and career navigation."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Continuous learning"
	                  ),
	                  " \u2014 Stay agile. Track trends, sector cycles, and emerging founders to spot opportunities."
	                )
	              ),
	              _react2.default.createElement("br", null)
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { "class": "row" },
	              _react2.default.createElement(
	                "div",
	                { "class": "col-md-12" },
	                _react2.default.createElement(
	                  "h2",
	                  { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                  "Speakers"
	                ),
	                "          ",
	                _react2.default.createElement("div", { "class": "r_btm" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "Our_Speakers container" },
	                  _react2.default.createElement(
	                    "center",
	                    null,
	                    _react2.default.createElement(
	                      "div",
	                      { className: "Speakers_img", style: { width: '80%' } },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        this.Speaker1.map(function (item, i) {
	                          if (i <= 12) {
	                            return _react2.default.createElement(
	                              "div",
	                              {
	                                className: "main_speaker_card col-md-3 col-sm-12 col-lg-3",
	                                key: i
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "Scardd" },
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "s_img",
	                                    onClick: function onClick() {
	                                      return _this3.togglePopUp(item);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "center",
	                                    null,
	                                    "  ",
	                                    _react2.default.createElement("img", {
	                                      src: item.imgUrl,
	                                      alt: item.name,
	                                      className: "img-responsive",
	                                      style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement("br", null),
	                                "    ",
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_name",
	                                  dangerouslySetInnerHTML: { __html: item.name }
	                                }),
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_post",
	                                  dangerouslySetInnerHTML: { __html: item.post }
	                                })
	                              )
	                            );
	                          } else return _react2.default.createElement(
	                            "div",
	                            {
	                              className: "main_speaker_card col-md-6 col-sm-12 col-lg-6",
	                              key: i
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "Scardd" },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "s_img",
	                                  onClick: function onClick() {
	                                    return _this3.togglePopUp(item);
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  "center",
	                                  null,
	                                  "  ",
	                                  _react2.default.createElement("img", {
	                                    src: item.imgUrl,
	                                    alt: item.name,
	                                    className: "img-responsive",
	                                    style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement("br", null),
	                              "    ",
	                              _react2.default.createElement("div", {
	                                className: "Speakers_name",
	                                dangerouslySetInnerHTML: { __html: item.name }
	                              }),
	                              _react2.default.createElement("div", {
	                                className: "Speakers_post",
	                                dangerouslySetInnerHTML: { __html: item.post }
	                              })
	                            )
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return SheShines;
	}(_react2.default.Component);
	
	SheShines.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SheShines;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-ignite-session-15-nov-2025-index-js-b0c75b76c7fedea3a296.js